





























































































import {Component, Vue} from 'vue-property-decorator';
import {HomeIcon, UserIcon, KeyIcon} from 'vue-feather-icons';
import {namespace} from 'vuex-class';

const Auth = namespace('Auth');

import {BizSirenEncodeResponse, BizSirenResultDto} from '@/services/LoginModels';
import {AxiosResponse} from 'axios';
import {MemberInfo, PMSResLogin, SexType, User, UserIdFind, YesOrNo} from '@/models';
import {loginService} from '@/services/login.service';

declare global {
  interface Window {
    recvSirenPhoneResult: any;
  }
}

@Component({
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
})
export default class FindId extends Vue {
  @Auth.Action
  private windowRef: any = null;
  private host = window.location.protocol + '//' + window.location.host;
  userIdFindDto: UserIdFind = {
    guestName: '',
    hpNo: '',
  };
  private reqInfo = '';
  private showUserId = false;
  private userId = '';

  mounted(): void {
    // eslint-disable-next-line
    window.recvSirenPhoneResult = this.recvSirenPhoneResult;
    this.$store.dispatch('Display/changeName', {name: '아이디찾기'});
  }

  goLoginPage(): void {
    this.$router.push('/p/login');
  }

  goFindPWPage(): void {
    this.$router.push('/p/FindPW');
  }

  openPhoneAuthPopup(): void {
    console.log('auth attempt');
    //console.log(this.authPhoneDto);

    //핸드폰 본인인증 창열
    const retUrl = this.host + '/noHeader/p/bizSirenCallBackPhone';
    loginService.getBizSirenEncode(retUrl).then(response => {
      if (response.status == 200) {
        const responseData = response.data as BizSirenEncodeResponse;
        this.reqInfo = responseData.reqInfo;
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v4.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = responseData.cryptoTokenId;
        element1.name = 'crypto_token_id';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = responseData.integrityValue;
        element2.name = 'integrity_value';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = responseData.reqInfo;
        element3.name = 'reqInfo';
        frm.appendChild(element3);

        const element4 = popupDocument.createElement('input');
        element4.type = 'hidden';
        element4.value = responseData.verSion;
        element4.name = 'verSion';
        frm.appendChild(element4);

        popupDocument.body.appendChild(frm);
        //this.windowRef.document.body.appendChild(this.$el);
        //copyStyles(window.document, this.windowRef.document);
        //this.windowRef.addEventListener('beforeunload', this.closePopup);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });
  }

  recvSirenPhoneResult(type: string, result: BizSirenResultDto, retInfo: string): void {
    console.log(result);
    this.userIdFindDto.guestName = result.name;
    this.userIdFindDto.hpNo = result.cellNo;

    loginService
      .userIdFindMissing(this.userIdFindDto)
      .then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          console.log(responseData);
          if (responseData.resultCode == '0000') {
            this.userId = responseData.obj.userId;
            this.$bvModal.show('findIDResult');
          } else {
            this.$bvModal.msgBoxOk('가입된 아이디가 존재하지 않습니다.', {
              title: '아이디 찾기',
              okVariant: 'danger',
              centered: true,
            });
          }
        } else {
          //http response 오류 처리
        }
      })
      .catch(error => {
        console.log(error.response);
        //window.opener.recvKakaoResult(error.response);
        this.$bvModal.msgBoxOk(error.response.data, {
          title: '아이디 검색실패',
          centered: true,
        });
      });
  }
}
